<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
        <a [routerLink]="['/']">Home</a>
    </li>
    <li>Agenda</li>
</ul>
<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>Agenda</strong>
        </span>

        <span style="float:right">
            <button class="btn btn-sm btn-primary mb-2" type="button" (click)="redirectToAddAgendaPage()"
                [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                <i class="fa fa-plus"></i>&nbsp;Add New Agenda</button>
        </span>
    </div>

    <section class="card search-box">
        <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
            <span class="pull-right">
                <i class="fa fa-filter" aria-hidden="true"></i>
            </span>
        </div>
        <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
            <div class="row">
                <div class="col-lg-12">
                    <form>
                        <div class="row agenda-filter-row">
                            <div class="col-md-2">
                                <label class="form-control-label">Agenda Title:</label>
                                <div class="form-group">
                                    <input class="form-control" [(ngModel)]="agendaNumberSearchParm" [ngModelOptions]="{standalone: true}">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <label class="form-control-label">Meeting Type:</label>
                                <div class="form-group">
                                    <select class="form-control" [(ngModel)]="meetingTypeSearch"
                                        (ngModelChange)="getMeetingFromType();getCategoryListFromMeetingFromAdvSearch()" [ngModelOptions]="{standalone: true}">
                                        <option value=null [selected]="true">Select</option>
                                        <option *ngFor="let meetingTypeList of meetingTypes" [value]="meetingTypeList._id">
                                            {{meetingTypeList.MeetingType}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3" *ngIf="categoryDisplay">
                                <label class="form-control-label">Category:</label>
                                <div class="form-group">
                                    <select class="form-control" [(ngModel)]="categorySearch" [ngModelOptions]="{standalone: true}">
                                        <option [selected]="true" value=null>Select</option>
                                        <option *ngFor="let category of categories" [value]="category._id">{{category.CategoryName}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3" [ngClass]="{'col-md-3': categoryDisplay, 'col-md-4': !categoryDisplay}">
                                <label class="form-control-label">Search By Type:</label>
                                <div class="form-group">
                                    <div class="checkbox-group-agenda">
                                        <label class="md-checkbox checkbox-inline">
                                            <input type="checkbox" id="Library" name="agendaType" (click)="cheackOne('Library')"
                                                [(ngModel)]="Library" [ngModelOptions]="{standalone: true}">
                                            <label class="checkbox-inline" for="Library">Library Agenda</label>
                                        </label>
                                        <label class="md-checkbox checkbox-inline">
                                            <input type="checkbox" id="NonLibrary" name="agendaType" (click)="cheackOne('Non-Library')"
                                                [(ngModel)]="NonLibrary" [ngModelOptions]="{standalone: true}">
                                            <label for="NonLibrary">Open Agenda</label>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2" [ngClass]="{'col-md-2': categoryDisplay, 'col-md-3': !categoryDisplay}">
                                <label class="form-control-label">&nbsp;</label>
                                <div class="form-group filter-actions-agenda">
                                    <button type="button" [disabled]="response" (click)="doAdvSearchAction()"
                                        class="btn btn-sm btn-primary" title="search">
                                        <i class="fa fa-search"></i>&nbsp;Search
                                    </button>
                                    <button type="button" [disabled]="response" (click)="clearAdvSearchResult()"
                                        class="btn btn-sm btn-default btn-clear" title="refresh">
                                        <i class="fa fa-refresh"></i>&nbsp;Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>

    <div class="card-block ">

    </div>
    <div class="card-block datatable-card-block" style="position: relative;">
        <!-- Loader overlay -->
        <div class="agenda-loader-overlay" *ngIf="isLoading">
            <div class="agenda-loader-container">
                <img src="assets/images/DigiCompany_loader.png" class="agenda-spinner" alt="Loading..." />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="datatabletool">

                    <div class="col-sm-4 ">
                        <label>&nbsp;&nbsp;&nbsp;</label>
                        <div class="input-group">
                            <!-- <button type="button" (click)="AddDataToMeeting()" [disabled]="!validCount" class="btn btn-sm btn-primary" [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}" >
                                        <i class="fa fa-check"></i>Add Selected To Meeting
                                    </button> -->
                            &nbsp;&nbsp;&nbsp;
                            <button type="button" (click)="deleteDataFromMeeting()" [disabled]="!validCount"
                                class="btn-sm btn btn-danger"
                                [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                                <span class="icmn-bin"></span>Delete Selected
                            </button>
                        </div>
                    </div>
                </div>
                <div class="margin-bottom-50">
                    <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="table table-hover compact cell-border nowrap stripe dataTable no-footere"
                            id="agendaTable" style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th style="display: none;">Agenda Number</th>
                                    <th style="width: 10%;">
                                        <div class='md-checkbox'>
                                            <input id='selectcheckboxall' class='md-checkbox md-checkbox-all'
                                                [(ngModel)]="checkAllAgenda" (ngModelChange)="selectAllAgenda($event)"
                                                type='checkbox' />
                                            <label for='selectcheckboxall'>&nbsp;</label>
                                        </div>
                                    </th>
                                    <th style="width: 10%;">Agenda Number</th>
                                    <th style="width: 10%;">Meeting Type</th>
                                    <th style="width: 25%;"> Agenda Title</th>
                                    <th style="width: 10%;">Group Number</th>
                                    <th style="width: 10%;">Group Name</th>
                                    <th style="width: 10%;">Category</th>
                                    <th style="width: 15%;">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let agenda of agendaData;let count=index">
                                    <!-- <tr *ngFor="let agenda of agendaData | orderBy: ['+Agendaorder'] ;let count=index" > -->
                                    <td style="display: none;">{{agenda._id}}</td>
                                    <td style="width: 10%;">
                                        <div class='md-checkbox'>
                                            <input type="checkbox" id="selectcheckbox{{ count +1 }}"
                                                class='md-checkbox md-checkbox-all'
                                                (ngModelChange)="selectSingleAgenda($event)"
                                                [(ngModel)]="agenda.IsSelected">
                                            <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td style="width: 10%; white-space: nowrap" tabindex="1">{{agenda.AgendaNumber}}
                                    </td>
                                    <td style="width: 10%; white-space: nowrap" tabindex="1">{{agenda.MeetingType}}</td>

                                    <td style="width: 25%; white-space: normal !important;" tabindex="1">
                                        {{agenda.AgendaTitle}}</td>
                                    <td style="width: 10%; white-space: nowrap" tabindex="1">
                                        <!-- {{agenda.groupNumber}} -->
                                        <ng-container
                                            *ngIf='agenda.groupIsGlobal==true || agenda.CompanyID==localStorageCompanyId'>
                                            {{agenda.groupNumber}}
                                        </ng-container>
                                    </td>
                                    <td style="width: 10%; white-space: nowrap" tabindex="1">
                                        <!-- {{agenda.groupName}} -->
                                        <ng-container
                                            *ngIf='agenda.groupIsGlobal==true || agenda.CompanyID==localStorageCompanyId'>
                                            {{agenda.groupName}}
                                        </ng-container>
                                    </td>

                                    <td tabindex="1" *ngIf="agenda.CategoryName">{{agenda.CategoryName}}</td>
                                    <td style="width: 10%; white-space: nowrap" tabindex="1"
                                        *ngIf="!agenda.CategoryName">N/A</td>
                                    <td style="width: 15%;">
                                        <button type="button" class="btn-sm btn btn-warning"
                                            (click)="loadAgendaByIdToEdit(agenda._id)">
                                            <span class="fa fa-pencil"></span>
                                        </button>
                                        <button type="button" class="btn-sm btn btn-danger" data-toggle="modal"
                                            data-target="#confirmation"
                                            (click)="showDeleteConfirmationPopUp(agenda._id,agenda.isGlobalCategory)"
                                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                                            <span class="icmn-bin"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <table datatable [dtOptions]="dtOptions2"  class="table table-hover compact cell-border nowrap stripe"
                        id="table2"   style="cursor: pointer;">
                    </table> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Add Category Modal -->
    <div class="modal fade modal-size-medium" id="categoryDialog" tabindex="-1" role="dialog" data-backdrop="static"
        data-keyboard="false" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form [formGroup]="categoryMasterForm" class="well">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModalLabel">Category Master</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-control-label">Category Type</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <label class="form-check-label">
                                        <input type="radio" [formControl]="categoryMasterForm.controls['IsGlobal']"
                                            style="position:absolute" name="IsGlobal" value="Global"
                                            class="form-check-input">Global</label>
                                    <label class="form-check-label">
                                        <input type="radio" [formControl]="categoryMasterForm.controls['IsGlobal']"
                                            style="position:absolute" name="IsGlobal" value="Company"
                                            class="form-check-input" checked="checked">Company</label>
                                </div>
                                <div *ngIf="categoryMasterForm.controls['IsGlobal'].hasError('required') && categoryMasterForm.controls['IsGlobal'].touched"
                                    class="form-control-error-custom">
                                    Category Type is required
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label class="form-control-label" for="l0">Category Name
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                </label>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <input [formControl]="categoryMasterForm.controls['CategoryName']"
                                        class="form-control" required="required">
                                    <div *ngIf="categoryMasterForm.controls['CategoryName'].hasError('required') && categoryMasterForm.controls['CategoryName'].touched"
                                        class="form-control-error-custom">
                                        Category Name is required
                                    </div>
                                    <div *ngIf="categoryMasterForm.controls['CategoryName'].hasError('maxlength') && categoryMasterForm.controls['CategoryName'].touched"
                                        class="form-control-error-custom">
                                        Category Name is invalid.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-control-label" for="l0">Meeting Type
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                </label>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <select [formControl]="categoryMasterForm.controls['MeetingType']"
                                        required="required" class="form-control select">
                                        <option value="null" disabled="true" [selected]="true">--Select Meeting Type--
                                        </option>
                                        <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                                            {{meetingType.MeetingType}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btnsaveCategory" type="button" class="btn-sm btn btn-primary"
                            [disabled]="!categoryMasterForm.valid" (click)="addCategory()">Save</button>
                        <button type="button" class="btn btn-sm" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <!-- Success Or Error Modal -->
    <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div id="alertTitle" class="modal-header"
                    style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                    Title!
                </div>
                <div class="modal-body">
                    <div id="alertMessage">
                        Message..
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Delete Confirmation Modal -->
    <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                        <i class="fa fa-question-circle-o mr-2"></i>&nbsp;Confirm
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            Are you sure you want to delete this agenda?
                            <span *ngIf="deleteGlobal">On deletion it will be deleted from all the companies.</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteAgenda()">
                        <i class="fa fa-check"></i>&nbsp;Yes</button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;No</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Add Bulk agenda in meeting Modal -->
    <div class="modal fade" id="addToMeetingModal" tabindex="-1" role="dialog" data-backdrop="static"
        data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                        <i class="fa fa-check"></i>&nbsp;Add Selected Agenda To Meeting
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                Agenda selected are
                                <b>{{agendaSelectedCount}}</b>.
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-control-label">Meeting Type</label>
                            <span _ngcontent-c2="" style="color: red;">*</span>
                        </div>
                        <div class="col-md-9">
                            <div class="form-group">
                                <select class="form-control" [(ngModel)]="AssignMeetingType"
                                    (ngModelChange)="getMeetingFromType()">
                                    <option value=null [selected]="true">Select</option>
                                    <option *ngFor="let meetingTypeList of meetingTypes" [value]="meetingTypeList._id">
                                        {{meetingTypeList.MeetingType}}</option>

                                </select>
                                <!-- <div *ngIf="agendaAddForm.controls['meetingType'].hasError('required') && agendaAddForm.controls['meetingType'].touched"
                                    class="form-control-error-custom">Meeting type is required
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-control-label">Meeting</label>
                            <span _ngcontent-c2="" style="color: red;">*</span>
                        </div>
                        <div class="col-md-9">
                            <select class="form-control" [(ngModel)]="AssingMeeting">
                                <option value=null [selected]="true">Select</option>
                                <option *ngFor="let meeting of meetingDateOnSelectedType" [value]="meeting._id">
                                    {{meeting.meetingList.MeetingDate | date: "dd-MM-y"}}
                                    {{meeting.meetingList.MeetingTime}}</option>
                            </select>
                        </div>
                        <!-- <div class="col-sm-12">
                            Are you sure you want to Add {{agendaSelectedCount}} agendas into Meeting?
                        </div> -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"
                        [disabled]="AssignMeetingType == null || AssignMeetingType == undefined  || AssingMeeting == null || AssingMeeting == undefined"
                        (click)="addSelectedToMeeting()">
                        <i class="fa fa-check"></i>&nbsp;Add To Meeting</button>

                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Close</button>
                </div>
            </div>
        </div>
    </div>


    <!-- Delete Confirmation Modal -->
    <div class="modal fade" id="deleteBulkAgenda" tabindex="-1" role="dialog" data-backdrop="static"
        data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                        <i class="fa fa-question-circle-o mr-2"></i>&nbsp;Confirm
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            Are you sure you want to delete selected agenda?
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteSelectedAgenda()">
                        <i class="fa fa-check"></i>&nbsp;Yes</button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;No</button>
                </div>
            </div>
        </div>
    </div>


</section>
<app-alert></app-alert>